// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_k2-0";
export var fileCarousel = "_k2-2";
export var removeFileButton = "_k2-1";